/**
 * Geocoding selection payload from AddressMapPicker / UserAddressField search.
 */
export interface GeocodeAddressSelection {
  street?: string;
  streetNumber?: string;
  city?: string;
  region?: string;
  state?: string;
  country?: string;
  countryCode?: string;
  postcode?: string;
  latitude?: number;
  longitude?: number;
  fullAddress?: string;
}

/**
 * User / work-address summary shape persisted on profile docs.
 */
export interface UserAddressFromGeocode {
  country: string;
  address: string;
  city: string;
  region: string;
  zip: string;
  location: { lat: number; lon: number } | null;
}

/**
 * Maps a map/geocode selection into the persisted user address shape.
 * Prefers ISO countryCode for national-ID rules when available.
 */
export const mapGeocodeSelectionToUserAddress = (
  value: GeocodeAddressSelection,
): UserAddressFromGeocode => {
  const street = (value.street || '').trim();
  const streetNumber = (value.streetNumber || '').trim();
  const addressLine = [street, streetNumber].filter(Boolean).join(' ').trim();
  const lat = typeof value.latitude === 'number' ? value.latitude : NaN;
  const lon = typeof value.longitude === 'number' ? value.longitude : NaN;
  const hasCoords = Number.isFinite(lat) && Number.isFinite(lon);

  return {
    country: (value.countryCode || value.country || '').trim(),
    address: addressLine || (value.fullAddress || '').trim(),
    city: (value.city || '').trim(),
    region: (value.region || value.state || '').trim(),
    zip: (value.postcode || '').trim(),
    location: hasCoords ? { lat, lon } : null,
  };
};
